import styled from "styled-components";

const Line = styled.div`
  border: 2px solid #151b1b;
  margin-bottom: 3vh;
`;

export default Line;
